import { render, staticRenderFns } from "./EsgScoresAndDetails.vue?vue&type=template&id=fb286a2c"
import script from "./EsgScoresAndDetails.vue?vue&type=script&lang=js"
export * from "./EsgScoresAndDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyEsgSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgSectionTitle.vue').default,IxSurveyEsgScore: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgScore.vue').default,IxSurveyEsgScoreSectionDetails: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgScoreSectionDetails.vue').default})
